import React from 'react';

export default function DocumentsReview() {
  return <div className="font-semibold">-- Documents component (WIP) --</div>;
}
